import { TButtonType } from '@r1-frontend/ui-react/components/buttons/button';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const getHoveringTextColorByType = (type: TButtonType): COLORS => {
    switch (type) {
        case 'action':
        case 'primary':
        case 'accent':
            return COLORS.TextWhite;
        case 'secondary':
        case 'white':
            return COLORS.TextPrimary;
        case 'ghost':
            return COLORS.TextHint;
    }
};

export default getHoveringTextColorByType;
